import Cookies from "js-cookie";
import i18n from "./i18next";
import moment from "moment";
import { store } from "..";
import { setGeneralLoadingSet } from "../ui/GeneralComponents/GeneralLoading/GeneralLoadingAction";
import { BASE_URL_UI } from "../config";
import { setPluginColumnClickedAndShouldBeRemoved, setPluginsDrillDowns, setTriggeredDrillDowns } from "../ui/DrillDown/DrillDownAction";
import {
  setPluginInteractionFiltersTrigger,
  setSourcePluginsWithValues,
  setPluginPrivateFiltersTrigger
} from "../ui/Plugins/PluginTriggerAction";
import { cloneDeep } from "lodash";
import $ from "jquery";
import { isAuthenticated } from "./Auth";

export const isEqual = require('fast-deep-equal/react');

/**
 * Dispatches an action. It is the only way to trigger a state change.
 * 
 * The reducer function, used to create the store, will be called with the current state tree and the given action. Its return value will be considered the next state of the tree, and the change listeners will be notified.
 * 
 * @param {*} action
 * @param {*} queued
 */
export const dispatch = (action, queued = false) => {
  if (action && queued) {
    setTimeout(store.dispatch, 0, action);
  } else if (action) {
    store.dispatch(action);
  }
}

/**
 * Absobates the event
 * 
 * @param {*} event 
 */
export const absorbEvent = (event = window.event) => {
  if (event) {
    event.preventDefault && event.preventDefault();
    event.stopPropagation && event.stopPropagation();
    event.cancelBubble = true;
    event.returnValue = false;
  }

  event = null;
}

export const navigate = (link, delayAsMilliseconds = 250) => {
  setTimeout(function () {
    window.location.href = link;
  }, delayAsMilliseconds);
};

/*
* Sets status of general loading
*/
export const changeStatusOfGeneralLoading = (key, status) => {
  let reduxState = store.getState()
  let copiedGeneralLoadingSet = new Set(reduxState.GeneralLoadingReducer.generalLoaderSet)

  if (status === true) {
    if (!copiedGeneralLoadingSet.has(key)) {
      copiedGeneralLoadingSet.add(key)

      store.dispatch(setGeneralLoadingSet(copiedGeneralLoadingSet))

      loadingScreen(status)
    }
  } else if (status !== true) {
    if (copiedGeneralLoadingSet.has(key)) {
      copiedGeneralLoadingSet.delete(key)

      store.dispatch(setGeneralLoadingSet(copiedGeneralLoadingSet))

      loadingScreen(status)
    }
  }
}

export const loadingScreen = status => {
  let reduxState = store.getState()
  let mustWaitedForAnotherProcesses = reduxState.GeneralLoadingReducer.generalLoaderSet.size > 0 ? true : false

  if (document.getElementById("splashScreenContainer")) {
    if (status == true) {
      document.getElementById("splashScreenContainer").style.display =
        "initial";
    } else if (status == false && (!mustWaitedForAnotherProcesses || !isAuthenticated())) {
      return document.getElementById("splashScreenContainer")
        ? (document.getElementById("splashScreenContainer").style.display =
          "none")
        : null;
    } else if (!mustWaitedForAnotherProcesses) {
      return document.getElementById("splashScreenContainer")
        ? document.getElementById("splashScreenContainer").style.display
        : "";
    }
  }
};

/** Delete a cookie. */
export const eraseCookie = (name, path) => {
  createCookie(name, "", -1, path);
};

export const createCookie = (name, value, days, path) => {
  if (days) {
    var date = new Date();
    date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
    var expires = "; expires=" + date.toGMTString();
  } else var expires = "";
  document.cookie = name + "=" + value + expires + "; path=" + path;
};

export const parseJwt = token => {
  var base64Url = token.split(".")[1];
  var base64 = base64Url.replace(/-/g, "+").replace(/_/g, "/");
  var jsonPayload = decodeURIComponent(
    atob(base64)
      .split("")
      .map(function (c) {
        return "%" + ("00" + c.charCodeAt(0).toString(16)).slice(-2);
      })
      .join("")
  );

  return JSON.parse(jsonPayload);
};

export const dateFormat = (date, splitter = "-") => {
  let formattedDateByLocalZone = new Date(date)
  let pureFormattedDate = moment(formattedDateByLocalZone).format()
  let splittedDate = pureFormattedDate.split("T")

  let dateParse = splittedDate[0].split("-");
  let timeParse = splittedDate[1].split(".")[0].split("+")[0]

  return dateParse[2] + splitter + dateParse[1] + splitter + dateParse[0] + " " + timeParse;
};

/**
 * Take tenant and return
 */
export const getTenant = () => {
  return Cookies.get("tenant");
};

export const dateBeforeCalculation = date => {
  let incomeDate = new Date(date);
  let today = new Date(Date.now());
  let difference = parseInt(
    (today.getTime() - incomeDate.getTime()) / (1000 * 3600 * 24)
  );
  let suffix = i18n.t("DateCalculation.Day");

  if (difference > 365) {
    difference /= 365;
    suffix = i18n.t("DateCalculation.Year");
  } else if (difference > 30) {
    difference /= 30;
    suffix = i18n.t("DateCalculation.Month");
  } else if (difference > 7) {
    difference /= 7;
    suffix = i18n.t("DateCalculation.Week");
  }

  if (difference > 1 && i18n.language === 'en') {
    suffix += "s";
  }

  return parseInt(difference) + suffix;
};

/**
 * Deep copy an object
 * 
 * **Note**\
 * This function was using `rfdc` to clone the object.\
 * However, we have been using `_.cloneDeep` in many parts of the project for a while now.\
 * Due to this situation, this function now uses `_.cloneDeep`.
 * 
 * @param {*} obj 
 * @returns 
 */
export const deepCopy = obj => {
  // Using lodash instead of rfdc.
  // const clone = require("rfdc")();
  // return clone(obj);

  return cloneDeep(obj);
};

export const getIcon = (icon, defaultIcon, style = {}, className) => {
  if (typeof icon === "string") {
    return <i style={style} class={`${icon} ${className || ""}`} />;
  }

  if (typeof icon === "object") {
    let name = icon.name;
    let type = icon.type;
    let value = icon.value;

    if (type === "font-awesome") {
      return <i style={style} class={`${value} ${className || ""}`} />;
    }

    if (type === "svg") {
      return (
        <span
          role="img"
          aria-label={name}
          class={`anticon ${className || ""}`}
          style={{
            width: "100%",
            height: "100%",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            ...style
          }}
          dangerouslySetInnerHTML={{ __html: value }}
        />
      )
    }
  }

  return defaultIcon;
}

/* 
* Changes the URL if the report is changed with the switcher and the report is get successfully.
*/
export function pushWindowHistoryIfComesFromDashboardSlider(
  sliderId
) {
  if (sliderId) {
    let newUrl =
      BASE_URL_UI +
      "/dashboard?sliderId=" +
      sliderId;

    window.history.replaceState({}, "", newUrl);
  }
}

/* 
* Changes the URL if the report is changed with the switcher and the report is get successfully.
*/
export function pushWindowHistoryIfComesFromSwitchDashboard(
  labelId,
  dashboardId
) {
  if (labelId) {
    const reduxState = store.getState();

    const isThemeUrlAvailable = reduxState.UrlParametersReducer.urlUtils.has("theme") ? reduxState.UrlParametersReducer.urlUtils.get("theme") : false;
    const isThemeAvailable = isThemeUrlAvailable ? `&?theme=${isThemeUrlAvailable}` : "";
    const newUrl = `${BASE_URL_UI}/dashboard/${dashboardId}?labelId=${labelId}${isThemeAvailable}`;

    window.history.replaceState({}, "", newUrl);
  }
}

/*
* Clears all interactions from plugin
*/
export function clearAllInteractionsOnPlugins() {
  const reduxState = store.getState();
  const pluginInteractionFilters = reduxState.PluginTriggerReducer.pluginInteractionFilters;
  const sourcePluginsWithValues = reduxState.PluginTriggerReducer.sourcePluginsWithValues;
  const pluginPrivateInteractionFilters = reduxState.PluginTriggerReducer.pluginPrivateInteractionFilters;

  pluginInteractionFilters.clear();
  sourcePluginsWithValues.clear();
  pluginPrivateInteractionFilters.clear();

  store.dispatch(setPluginInteractionFiltersTrigger(pluginInteractionFilters));
  store.dispatch(setSourcePluginsWithValues(sourcePluginsWithValues));
  store.dispatch(setPluginPrivateFiltersTrigger(pluginPrivateInteractionFilters));
}

/*
* Clears all drilldowns from plugin
*/
export function clearAllDrillDownsOnPlugins() {
  const reduxState = store.getState();
  const drillDowns = reduxState.DrillDownReducer.drillDowns;
  const triggeredDrillDowns = reduxState.DrillDownReducer.triggeredDrillDowns;
  const pluginColumnClickedAndShouldBeRemoved = reduxState.DrillDownReducer.pluginColumnClickedAndShouldBeRemoved;

  drillDowns.clear();
  triggeredDrillDowns.clear();
  pluginColumnClickedAndShouldBeRemoved.clear();

  store.dispatch(setTriggeredDrillDowns(triggeredDrillDowns));
  store.dispatch(setPluginColumnClickedAndShouldBeRemoved(pluginColumnClickedAndShouldBeRemoved));
  store.dispatch(setPluginsDrillDowns(drillDowns));
};

/**
 * Returns the popup parent container of the trigger element
 * 
 * @param {*} trigger 
 * @returns 
 */
export const getPopupContainer = (trigger, query) => {
  let $trigger = $(trigger);
  let parents = Array.from($trigger.parents());
  let parent = trigger?.parentNode;

  if ($trigger.is(query)) {
    return trigger
  }

  if (query) {
    for (let p of parents) {
      let $p = $(p);

      if ($p.is(query) || $p.is("body")) {
        $p = null;
        parent = p;

        break;
      }
    }
  }

  $trigger = null;
  parents = null;

  return parent;
};
/**
 * Checks if the column has an aggregation
 * 
 * @param {Object} column - the column to check
 */
export const hasColumnAggregation = (column) => {
  const { aggRule, aggregatable, columnType, value, columnDefaultFormula } = column;
  const checkExpression = exp => {
    const aggregations = ["SUM(", "COUNT(", "DISTINCT(", "AVG(", "MAX(", "MIN("];

    exp = exp?.toUpperCase()?.replaceAll(/[\s]+/g, "");

    return aggregations.some(agg => exp?.startsWith(agg));
  };

  if (aggRule || aggregatable) return true;
  if (checkExpression(value)) return true;
  if (columnType === "newColumn" && checkExpression(columnDefaultFormula)) return true;

  return false;
};

export const getScaleValue = () => {
  const transform = $("#gridLayout").css("transform");

  if (transform === "none") return 1; // Default scale is 1 if no transform is applied

  // Extract values from the matrix
  const matrixValues = transform.match(/matrix\(([^)]+)\)/);
  if (!matrixValues) return 1;

  const values = matrixValues[1].split(", ");
  return parseFloat(values[0]); // ScaleX is the first value
};

/**
 * Stores the current dashboard ID in session storage
 * @param {string} dashboardId - The dashboard ID to store
 */
export const setCurrentDashboardId = (dashboardId) => {
  if (dashboardId) {
    sessionStorage.setItem("currentDashboardId", dashboardId);
  } else {
    sessionStorage.removeItem("currentDashboardId");
  }
};

/**
 * Retrieves the current dashboard ID from session storage
 * @returns {string|null} The stored dashboard ID or null if not found
 */
export const getCurrentDashboardId = () => {
  const dashboardId = sessionStorage.getItem("currentDashboardId") || undefined;

  return dashboardId;
};

/**
 * Removes the current dashboard ID from session storage
 */
export const removeCurrentDashboardId = () => {
  sessionStorage.removeItem("currentDashboardId");
};

/**
 * Swaps the position of the desired element in an array 
 * 
 * @param {Array} array 
 * @param {Number} currentIndex 
 * @param {Number} targetIndex 
 * @returns 
 */
export const arraySwapPosition = (array = [], currentIndex = 0, targetIndex = 0) => {
  let result = [...array];

  if (currentIndex !== targetIndex) {
    if (targetIndex >= result.length) {
      let k = targetIndex - result.length;

      while ((k--) + 1) {
        result.push(undefined);
      }
    }

    result.splice(targetIndex, 0, result.splice(currentIndex, 1)[0]);
  }

  return result;
}

/**
 * Checks is the event child of the given parent node
 * 
 * @param {Object} event 
 * @param {String} parent 
 * @returns 
 */
export const checkEventInheritance = (event, parent) => {
  const x = event.clientX;
  const y = event.clientY;
  const target = document.elementFromPoint(x, y);

  return target && target.closest(parent) !== null;
}